import type { ApiPlayerDetails } from "../../../api";
import { UploadedImage } from "../../../components";
import styles from "./PlayerAvatar.module.css";

export const PlayerAvatar = ({ player }: { player: ApiPlayerDetails }) => {
  return (
    <UploadedImage
      className={styles["player-avatar"]}
      image={player.headshot}
      alt={`${player.firstName} ${player.lastName}`}
      aspectRatio="2/3"
      objectFit="cover"
      h="5rem"
      tracking={{
        enabled: true,
        location: "PowerupPlayers::PlayerAvatar",
      }}
    />
  );
};
